export enum NotificationProcessorType {
    ASSIGNMENT = 'ASSIGNMENT',
    UNASSIGNMENT = 'UNASSIGNMENT',
    GET_ALL = 'GET_ALL'
}